import React, { useState, useEffect, useRef } from 'react';
import {Button, Hidden, IconButton, Typography} from '@mui/material';
import {AddBox, ChevronRightRounded} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import MaterialTable from 'material-table';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { getMediaURL} from "../../../../config/values";
import {TableCount, TablePage} from "../../../../config/Permissions";
import {getDataTableLocalization} from "../../../../config/Translate";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {tableIcons} from "../../../../config/design/TableIcons";
import {defaultVariables} from "../../../../config";
import {useIsSmall} from "../../../../config/hooks/useWindowDimensions";
import {useTranslation} from "react-i18next";
import {Eye} from "lucide-react";
import ChevronForward from "../../../components/icons/ChevronForward";

const Pages = ({ classes }) => {
    const isSmall = useIsSmall();
    const { t } = useTranslation();

    const [columns] = useState([
/*        {
            field: 'thumbnail',
            editable: 'never',
            filtering: false,
            sorting: false,
            hidden: isSmall,
            title: t('thumbnail'),
            render: rowData => !!rowData.thumbnail && <img alt="avatar" src={rowData.thumbnail} className={classes.FMThumbnail} />
        },*/
        {
            title: t('pageName'),
            field: 'name',
            filterPlaceholder: t('search'),
            sorting: false,
        },
        {
            title: t('activity'),
            editable: 'never',
            field: 'activity',
            sorting: false,
            render: rowData => (
                <>
                    <Button
                        variant="outlined"
                        color="secondary"
                        component={Link}
                        to={`/manage/pages/edit/${rowData.id}`}
                        endIcon={<ChevronForward />}
                        size="small"
                        style={{ margin: 5 }}
                    >
                        {t('details')}
                    </Button>
                </>

            )
        }
    ]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const tableRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () => {
        tableRef.current && tableRef.current.onQueryChange();
    };

    const onDelete = async (id, hasNotif = true) => {
        try {
            const loginToken = localStorage.getItem('ACT');
            let data = new FormData();
            data.append('id', id);
            await axios.post(`${defaultVariables.url}/pages/remove`, data, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            });
            loadData();
        } catch (error) {
            console.log(error.response)
            enqueueSnackbar(t('deleteDataFailed'), { variant: 'error' });
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            {
                loading ? "Loading" :
                    <div className="main-table">
                        <MaterialTable
                            tableRef={tableRef}

                            icons={tableIcons}
                            title={" "}
                            localization={getDataTableLocalization()}
                            columns={columns}
                            data={query =>
                                new Promise((resolve, reject) => {
                                    axios.get(`${defaultVariables.url}/pages/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, {
                                        headers: {
                                            Accept: 'application/json',
                                            Authorization: `Bearer ${localStorage.getItem('ACT')}`
                                        }
                                    }).then(response => {
                                        const data = response.data.data.map(row => ({
                                            id: row.id,
                                            name: row.name,
                                            slug: row.slug,
                                            thumbnail:getMediaURL(row.thumbnail,'small'),
                                            created_at: row.created_at,
                                        }));
                                        resolve({
                                            data: data,
                                            page: response.data.current_page - 1,
                                            totalCount: response.data.total
                                        });
                                    }).catch(error => console.log(error.response));
                                })
                            }
                            options={{
                                pageSize: TablePage,
                                pageSizeOptions: TableCount,
                                defaultExpanded: false,
                                draggable: false,
                            }}
                            editable={{
                                onRowDelete: oldData =>
                                    new Promise(resolve => {
                                        setTimeout(() => {
                                            resolve();
                                            onDelete(oldData.id);
                                            setData(prevData => prevData.filter(item => item.id !== oldData.id));
                                        }, 600);
                                    })
                            }}
                        />
                    </div>
            }
        </>
    );
};
export default withStyles(Styles)(Pages);
